import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import styles from "./Navbar.module.css";
import Sun from "../assets/webp/sunlight.webp";
import junglemorals from "../assets/webp/Asset.webp";
import Sunlight from "../assets/webp/sunrays_2.png";
import cloud1 from "../assets/webp/cloud1.webp";
import cloud2 from "../assets/webp/cloud2.webp";
import cloud3 from "../assets/webp/cloud4.webp";
import cloud4 from "../assets/webp/cloud1.webp";
import cloud5 from "../assets/webp/cloud5.webp";
function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const activeColor = "#45c51a";
  const inactiveColor = "#0f766e";

  // Check if mobile AND whatwedo page
  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 480);
  const isWhatWeDoPage = location.pathname === '/whatwedo';
  const isBlogPage = location.pathname.startsWith("/blog");

  
  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 480);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    <div
      className={styles.backgroundsky}
      //add new
        style={{
        // SIRF mobile + whatwedo page pe apply hoga
        ...(isMobile && isWhatWeDoPage && { 
          minHeight: '120vh',
          height: 'auto'
        }),
        ...(isBlogPage && {     
      height: 'auto',  // auto kar do
      minHeight: '80vh', // min height set karo
      backgroundSize: 'cover',
      // backgroundPosition: 'top center'
 }),
        ...(isBlogPage && isMobile &&{ height: '15vh' })
      }}

      >
      <div style={{
        height: "300px",
      }} >
        <div className="position-absolute top-0 start-0 w-100 h-100 opacity-25" style={{ pointerEvents: 'none' }}>
          <div
            className="position-absolute top-0 start-0 w-100 h-100"
            style={{
              backgroundImage:
                "repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(255,255,255,0.3) 35px, rgba(255,255,255,0.3) 70px)",
              pointerEvents: 'none'
            }}
          ></div>
        </div>
        <div
          className="position-absolute top-0 start-0"
          style={{ width: "200px", height: "200px", zIndex: 3 }}
        >
          <div className="position-relative w-100 h-100">

            <img
              src={Sunlight}
              alt="Sunlight"
              className={`${styles.sunLight}  object-fit-contain `}
              
            />
            <img
              src={Sun}
              alt="Sun"
              className={`${styles.sun} start-0 `}
  //  onClick={() => {
  //   if (location.pathname === '/') {
  //     window.location.reload();
  //   } else {
  //     navigate('/');
  //   }
  // }}
  // style={{ cursor: 'pointer' }}
            />

            <img
              src={junglemorals}
              alt="Jungle Morals"
              className={`object-fit-contain ${styles.jungleMorals}`}
            onClick={() => {
    if (location.pathname === '/') {
      window.location.reload();
    } else {
      navigate('/');
    }
  }}
  style={{ cursor: 'pointer' }}
            />
          </div>
        </div>

        <div className="position-relative h-100 d-flex align-items-center justify-content-end pe-5">
          <div
            className="position-relative"
            style={{ width: "600px", height: "300px", paddingRight: "100px" }}
          >
            <div className={`position-absolute z-100 ${styles.homeCloudOuter}`}>
              <Link to="/" className={`position-relative ${styles.homeCloud}`} style={{ display: 'block' }}>
                <img src={cloud4} alt="cloud" className="position-absolute w-100 h-110 z-5000 object-fit-contain" />
                <div className={`position-absolute w-100 h-100 d-flex align-items-center z-5000 justify-content-center`}>
                  <span className={`font-adventuring ${styles.homeCloudText}`} style={{ color: location.pathname === "/" ? activeColor : inactiveColor }}>
                    Home
                  </span>
                </div>
              </Link>
            </div>

            <div className={`position-absolute  z-3 ${styles.theWhyCloudOuter}`}>
              <Link to="/thewhy" className={`position-relative ${styles.theWhyCloud}`} style={{ display: 'block' }}>
                <img src={cloud2} alt="cloud" className="position-absolute w-100 h-120 object-fit-contain" />
                <div className="position-absolute w-100 h-100 d-flex align-items-center justify-content-center">
                  <span className={`font-adventuring ${styles.theWhyCloudText}`} style={{ color: location.pathname === "/thewhy" ? activeColor : inactiveColor }}>
                    The Why
                  </span>
                </div>
              </Link>
            </div>

            <div className={`position-absolute  z-92 ${styles.whatCloudOuter}`}>
              <Link to="/whatwedo" className={`position-relative ${styles.whatCloud}`} style={{ display: 'block' }}>
                <img src={cloud1} alt="cloud" className="position-absolute z-6000 w-100 h-110 object-fit-contain" />
                <div className="position-absolute w-100 h-100 d-flex align-items-center z-6000 justify-content-center">
                  <span className={`font-adventuring ${styles.whatCloudText}`} style={{ color: location.pathname === "/whatwedo" ? activeColor : inactiveColor }}>
                    What We Do
                  </span>
                </div>
              </Link>
            </div>

            <div className={`position-absolute  z-2 ${styles.charactersCloudOuter}`}>
              <Link to="/characters" className={`position-relative ${styles.charactersCloud}`} style={{ display: 'block' }}>
                <img src={cloud3} alt="cloud" className="position-absolute w-100 h-110 object-fit-contain" />
                <div className="position-absolute w-100 h-100 d-flex align-items-center justify-content-center">
                  <span className={` font-adventuring ${styles.charactersCloudText}`} style={{ color: location.pathname === "/characters" ? activeColor : inactiveColor }}>
                    Characters
                  </span>
                </div>
              </Link>
            </div>


            <div className={`position-absolute  z-2 ${styles.emptyCloudOuter}`}>
              <Link to="/about" className={`position-relative ${styles.emptyCloud}`} style={{ display: 'block' }}>
                <img src={cloud5} alt="cloud" className="position-absolute w-100 h-100  object-fit-contain" />
                <div className="position-absolute w-100 h-100 d-flex align-items-center justify-content-center">
                  <span className={` font-adventuring ${styles.aboutCloudText}`} style={{ color: location.pathname === "/about" ? activeColor : inactiveColor }}>
                    About Us
                  </span>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Navbar;




